import { useAgents } from "@/features/agents/hooks/use-agents";
import type { MetaChannel } from "@/features/connectors";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { AgentField } from "../connector-form/fields-channel";
import { PagesPanel } from "./pages-panel";
import { WhatsAppPanel } from "./whatsapp-panel";

/**
 * Connect a WhatsApp number, a Facebook Page or an Instagram account with the
 * company's own Meta login. Nothing here is typed in — the backend refuses a
 * `meta` connector built from a payload — so it is a configurator of its own,
 * not a type of the generic connector form. The window around it, and the choice
 * of channel, belong to the picker (`add-channel/`).
 */
export const MetaChannelSetup = ({
  channel,
  onConnected,
}: {
  channel: MetaChannel;
  onConnected: () => void;
}) => {
  const { company: clientId = "" } = useParams<{ company: string }>();
  const { data: agents = [] } = useAgents();
  const [agentId, setAgentId] = useState("");

  return (
    <div className="space-y-4 py-2">
      <AgentField agentId={agentId} onChange={setAgentId} agents={agents} />

      {channel === "whatsapp" ? (
        <WhatsAppPanel
          clientId={clientId}
          agentId={agentId}
          onConnected={onConnected}
        />
      ) : (
        <PagesPanel
          clientId={clientId}
          channel={channel}
          agentId={agentId}
          onConnected={onConnected}
        />
      )}
    </div>
  );
};
